// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__12Vec","answered":"Icon_answered__3zc7E","unanswered":"Icon_unanswered__1M5vF","current":"Icon_current__1Jvge"};